export const chitsAvailable = (project) =>
  project && project.id && !["draft"].includes(project.aasm_state);

export const toMoney = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    value,
  );

export const filterChit = (chit) => chit.lineItems.length > 0;
